// MARK://dhk8/pos/lib/queries/kds
// Queries tipadas de comandas de cocina — F4.3 / ADR-0009. El POS lee el KDS por el
// grafo (kds-tickets, tenant del JWT). Acciones (start/ready/bump/recall/priority/
// item-status) + realtime siguen REST/WS. Campos inline (el preset `client` de codegen
// NO evalúa interpolaciones en el tag `graphql`).
import { graphql } from '../../gql/index.js'

export const PosKitchenTicketsQuery = graphql(`
  query PosKitchenTickets($branchId: String, $stationId: String, $orderId: String, $status: String, $active: Boolean, $page: Int, $limit: Int) {
    kitchenTickets(branchId: $branchId, stationId: $stationId, orderId: $orderId, status: $status, active: $active, page: $page, limit: $limit) {
      items {
        id tenantId branchId orderId stationId ticketNumber status priority orderType tableCode
        firedAt startedAt readyAt bumpedAt recalledAt notes
        items { id orderItemId name quantity notes status modifiers { name priceDeltaCents } }
      }
    }
  }
`);

export const PosKitchenTicketQuery = graphql(`
  query PosKitchenTicket($id: ID!) {
    kitchenTicket(id: $id) {
      id tenantId branchId orderId stationId ticketNumber status priority orderType tableCode
      firedAt startedAt readyAt bumpedAt recalledAt notes
      items { id orderItemId name quantity notes status modifiers { name priceDeltaCents } }
    }
  }
`);


// ── F8.1 / ADR-0009: acciones del KDS por el grafo (mutations, tenant del JWT) ──
export const PosKdsStartTicketMutation = graphql(`
  mutation PosKdsStartTicket($id: ID!) {
    startKitchenTicket(id: $id) {
      id tenantId branchId orderId stationId ticketNumber status priority orderType tableCode
      firedAt startedAt readyAt bumpedAt recalledAt notes
      items { id orderItemId name quantity notes status modifiers { name priceDeltaCents } }
    }
  }
`);

export const PosKdsReadyTicketMutation = graphql(`
  mutation PosKdsReadyTicket($id: ID!) {
    readyKitchenTicket(id: $id) {
      id tenantId branchId orderId stationId ticketNumber status priority orderType tableCode
      firedAt startedAt readyAt bumpedAt recalledAt notes
      items { id orderItemId name quantity notes status modifiers { name priceDeltaCents } }
    }
  }
`);

export const PosKdsBumpTicketMutation = graphql(`
  mutation PosKdsBumpTicket($id: ID!) {
    bumpKitchenTicket(id: $id) {
      id tenantId branchId orderId stationId ticketNumber status priority orderType tableCode
      firedAt startedAt readyAt bumpedAt recalledAt notes
      items { id orderItemId name quantity notes status modifiers { name priceDeltaCents } }
    }
  }
`);

export const PosKdsRecallTicketMutation = graphql(`
  mutation PosKdsRecallTicket($id: ID!) {
    recallKitchenTicket(id: $id) {
      id tenantId branchId orderId stationId ticketNumber status priority orderType tableCode
      firedAt startedAt readyAt bumpedAt recalledAt notes
      items { id orderItemId name quantity notes status modifiers { name priceDeltaCents } }
    }
  }
`);

export const PosKdsSetPriorityMutation = graphql(`
  mutation PosKdsSetPriority($id: ID!, $priority: Int!) {
    setKitchenTicketPriority(id: $id, priority: $priority) {
      id tenantId branchId orderId stationId ticketNumber status priority orderType tableCode
      firedAt startedAt readyAt bumpedAt recalledAt notes
      items { id orderItemId name quantity notes status modifiers { name priceDeltaCents } }
    }
  }
`);

export const PosKdsSetItemStatusMutation = graphql(`
  mutation PosKdsSetItemStatus($ticketId: ID!, $itemId: ID!, $status: String!) {
    updateKitchenTicketItemStatus(ticketId: $ticketId, itemId: $itemId, status: $status) {
      id tenantId branchId orderId stationId ticketNumber status priority orderType tableCode
      firedAt startedAt readyAt bumpedAt recalledAt notes
      items { id orderItemId name quantity notes status modifiers { name priceDeltaCents } }
    }
  }
`);
